import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/**
 * 客戶訂單列表。
 * 未指定 sort 時後端預設 `customer_order_no,desc`；前端可不硬送 sort。
 *
 * @param {object} listQuery
 */
export async function fetchCustomerOrderList(listQuery) {
  const { data: raw } = await request.get('/crm/customer-order', {
    params: listQueryToApiParams(joinMultiValueFilters(listQuery)),
  });
  return parseVer4ListResponse(raw);
}
